/** Consulta ve el módulo. No puede cargar, guardar ni borrar. */

export function esConsultaAnalisis(user) {
  const role = String(user?.role || "").trim().toLowerCase();
  const despacho = String(
    user?.despacho_profile?.despacho_role || user?.despacho_role || "",
  ).trim().toLowerCase();
  return role === "consulta" || despacho === "consulta";
}

export function puedeEscribirAnalisisFinanciero(user) {
  if (!user || user === false) return false;
  if (esConsultaAnalisis(user)) return false;
  const despacho = String(
    user?.despacho_profile?.despacho_role || user?.despacho_role || "",
  ).trim().toLowerCase();
  if (despacho !== "auxiliar" && despacho !== "supervisor") return true;
  const rows = user.team_role_permissions;
  if (!Array.isArray(rows) || !rows.length) return true;
  const row = rows.find((r) => r?.id === "analisis_financiero");
  if (!row) return true;
  return Boolean(row[despacho]);
}
